import AxiosInstance from "./api";

export const AssetHandoverRecordService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/asset-handover-record", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/asset-handover-record/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/asset-handover-record", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/asset-handover-record/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/asset-handover-record/${id}`);
  },
};
